import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i6.14
import React from 'react';
import IconWrap from '../IconWrap';
const DefaultView = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19 5v14H5V5h14zm1-2H4a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1V4a1 1 0 00-1-1z"
    })));
};
DefaultView.displayName = 'DefaultView';
export default DefaultView;
